import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { AdminHeader } from '../../components';
import { surveyReportService, storageService } from '../../services';
import DemandReport from './DemandReport';
import ControlReport from './ControlReport';
import SupportReport from './SupportReport';
import SupportManagerReport from './SupportManagerReport';
import SupportPeerReport from './SupportPeerReport';
import RoleReport from './RoleReport';
import RelationshipReport from './RelationshipReport';
import ChangeReport from './ChangeReport';
import NextStepsReport from './NextStepsReport';
import { LeftMenu, MainHeader } from '../../components';
import { isEmpty, forEach } from 'lodash';
import { routesObj } from '../../routes';
import {
  questionCategoryType,
  MenuItems,
  QueryStringTokens,
} from '../../utils';
import { SurveyTypes, WebStorageNames } from '../../utils/Constants';
import { loaderAction } from '../../store/loaderStore';
import { navigationActions } from '../../store/headerStore';
import {
  DownloadButtonStyle,
  AssistanceWrapper,
} from '../../resources/styling/appStyle';
import { parseJwt, amplitudeLog } from '../../utils/CommonFunctions';
import { config } from '../../utils/config';
import Tooltip from '@mui/material/Tooltip';
import SurveyListDropDown from '../../components/common/SurveyListDropDown';
import { surveyResultService, surveyService } from '../../services';
import {
  getQueryStringVal,
  getTransformedSurveyRecordList,
} from '../../utils/CommonFunctions';
import { IsActionAllowed, RestrictedActions } from '../../utils';
import { iconDownload } from '../../resources/images/index';
import Grid from '@mui/material/Grid';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import {
  SurveyReportWrapper,
  SurveyReportInnerWrapper,
  SubHeading,
  SurveyDate,
  SurveyCompleted,
  SurveyReportIntro,
  ExtendedReportDropDown,
} from './SurveyReportStyle';
import { withTranslation } from 'react-i18next';
import AccessLevel from '../../components/common/AccessLevel';
import {
  AccessPermissions,
  Roles
} from '../../utils/Constants';

const drawerWidth = 240;

class SurveyReport extends Component {
  constructor(props) {
    super(props);
    const token = storageService.getItem(WebStorageNames.Token);
    const userInfo = parseJwt(token);

    this.state = {
      isPaid: false,
      surveyReport: {
        Demands: {
          Category: 6,
          ResultsText: '',
          HseStrengths: [],
          HseWeaknesses: [],
          SchoolStrengths: [],
          SchoolWeaknesses: [],
          SchoolSuggestions: {},
          HseSuggestions: {},
          Score: {
            Category: 0,
            CategoryName: '',
            HseDecilesCategoryAverage: '',
            OverallCategoryAverage: 0,
            SchoolDecilesCategoryAverage: '',
            SupportStaffCategoryAverage: 0,
            TeachingStaffCategoryAverage: 0,
            SupportStaffClassCatAvg: 0,
            SupportStaffNonClassCatAvg: 0,
            TeachingStaffClassCatAvg: 0,
            TeachingStaffNonClassCatAvg: 0,
            SeniorLeaderCatAvg: 0,
            MiddleLeaderCatAvg: 0,
          },
        },
        Control: {
          Category: 2,
          ResultsText: '',
          HseStrengths: [],
          HseWeaknesses: [],
          SchoolStrengths: [],
          SchoolWeaknesses: [],
          SchoolSuggestions: '',
          HseSuggestions: '',
          Score: {
            Category: 0,
            CategoryName: '',
            HseDecilesCategoryAverage: '',
            OverallCategoryAverage: 0,
            SchoolDecilesCategoryAverage: '',
            SupportStaffCategoryAverage: 0,
            TeachingStaffCategoryAverage: 0,
            SupportStaffClassCatAvg: 0,
            SupportStaffNonClassCatAvg: 0,
            TeachingStaffClassCatAvg: 0,
            TeachingStaffNonClassCatAvg: 0,
            SeniorLeaderCatAvg: 0,
            MiddleLeaderCatAvg: 0,
          },
        },
        ManagerSupport: {
          Category: 3,
          ResultsText: '',
          HseStrengths: [],
          HseWeaknesses: [],
          SchoolStrengths: [],
          SchoolWeaknesses: [],
          SchoolSuggestions: '',
          HseSuggestions: '',
          Score: {
            Category: 0,
            CategoryName: '',
            HseDecilesCategoryAverage: '',
            OverallCategoryAverage: 0,
            SchoolDecilesCategoryAverage: '',
            SupportStaffCategoryAverage: 0,
            TeachingStaffCategoryAverage: 0,
            SupportStaffClassCatAvg: 0,
            SupportStaffNonClassCatAvg: 0,
            TeachingStaffClassCatAvg: 0,
            TeachingStaffNonClassCatAvg: 0,
            SeniorLeaderCatAvg: 0,
            MiddleLeaderCatAvg: 0,
          },
        },
        PeerSupport: {
          Category: 4,
          ResultsText: '',
          HseStrengths: [],
          HseWeaknesses: [],
          SchoolStrengths: [],
          SchoolWeaknesses: [],
          SchoolSuggestions: '',
          HseSuggestions: '',
          Score: {
            Category: 0,
            CategoryName: '',
            HseDecilesCategoryAverage: '',
            OverallCategoryAverage: 0,
            SchoolDecilesCategoryAverage: '',
            SupportStaffCategoryAverage: 0,
            TeachingStaffCategoryAverage: 0,
            SupportStaffClassCatAvg: 0,
            SupportStaffNonClassCatAvg: 0,
            TeachingStaffClassCatAvg: 0,
            TeachingStaffNonClassCatAvg: 0,
            SeniorLeaderCatAvg: 0,
            MiddleLeaderCatAvg: 0,
          },
        },
        Relationships: {
          Category: 6,
          ResultsText: '',
          HseStrengths: [],
          HseWeaknesses: [],
          SchoolStrengths: [],
          SchoolWeaknesses: [],
          SchoolSuggestions: {},
          HseSuggestions: {},
          Score: {
            Category: 0,
            CategoryName: '',
            HseDecilesCategoryAverage: '',
            OverallCategoryAverage: 0,
            SchoolDecilesCategoryAverage: '',
            SupportStaffCategoryAverage: 0,
            TeachingStaffCategoryAverage: 0,
            SupportStaffClassCatAvg: 0,
            SupportStaffNonClassCatAvg: 0,
            TeachingStaffClassCatAvg: 0,
            TeachingStaffNonClassCatAvg: 0,
            SeniorLeaderCatAvg: 0,
            MiddleLeaderCatAvg: 0,
          },
        },
        Role: {
          Category: 6,
          ResultsText: '',
          HseStrengths: [],
          HseWeaknesses: [],
          SchoolStrengths: [],
          SchoolWeaknesses: [],
          SchoolSuggestions: {},
          HseSuggestions: {},
          Score: {
            Category: 0,
            CategoryName: '',
            HseDecilesCategoryAverage: '',
            OverallCategoryAverage: 0,
            SchoolDecilesCategoryAverage: '',
            SupportStaffCategoryAverage: 0,
            TeachingStaffCategoryAverage: 0,
            SupportStaffClassCatAvg: 0,
            SupportStaffNonClassCatAvg: 0,
            TeachingStaffClassCatAvg: 0,
            TeachingStaffNonClassCatAvg: 0,
            SeniorLeaderCatAvg: 0,
            MiddleLeaderCatAvg: 0,
          },
        },
        Change: {
          Category: 6,
          ResultsText: '',
          HseStrengths: [],
          HseWeaknesses: [],
          SchoolStrengths: [],
          SchoolWeaknesses: [],
          SchoolSuggestions: {},
          HseSuggestions: {},
          Score: {
            Category: 0,
            CategoryName: '',
            HseDecilesCategoryAverage: '',
            OverallCategoryAverage: 0,
            SchoolDecilesCategoryAverage: '',
            SupportStaffCategoryAverage: 0,
            TeachingStaffCategoryAverage: 0,
            SupportStaffClassCatAvg: 0,
            SupportStaffNonClassCatAvg: 0,
            TeachingStaffClassCatAvg: 0,
            TeachingStaffNonClassCatAvg: 0,
            SeniorLeaderCatAvg: 0,
            MiddleLeaderCatAvg: 0,
          },
        },
        Skills: {
          Category: 8,
          ResultsText: '',
          HseStrengths: [],
          HseWeaknesses: [],
          SchoolStrengths: [],
          SchoolWeaknesses: [],
          SchoolSuggestions: {},
          HseSuggestions: {},
          Score: {
            Category: 0,
            CategoryName: '',
            HseDecilesCategoryAverage: '',
            OverallCategoryAverage: 0,
            SchoolDecilesCategoryAverage: '',
            SupportStaffCategoryAverage: 0,
            TeachingStaffCategoryAverage: 0,
            SupportStaffClassCatAvg: 0,
            SupportStaffNonClassCatAvg: 0,
            TeachingStaffClassCatAvg: 0,
            TeachingStaffNonClassCatAvg: 0,
            SeniorLeaderCatAvg: 0,
            MiddleLeaderCatAvg: 0,
          },
        },
        Career: {
          Category: 9,
          ResultsText: '',
          HseStrengths: [],
          HseWeaknesses: [],
          SchoolStrengths: [],
          SchoolWeaknesses: [],
          SchoolSuggestions: {},
          HseSuggestions: {},
          Score: {
            Category: 0,
            CategoryName: '',
            HseDecilesCategoryAverage: '',
            OverallCategoryAverage: 0,
            SchoolDecilesCategoryAverage: '',
            SupportStaffCategoryAverage: 0,
            TeachingStaffCategoryAverage: 0,
            SupportStaffClassCatAvg: 0,
            SupportStaffNonClassCatAvg: 0,
            TeachingStaffClassCatAvg: 0,
            TeachingStaffNonClassCatAvg: 0,
            SeniorLeaderCatAvg: 0,
            MiddleLeaderCatAvg: 0,
          },
        },
        NextSteps: {
          Demand: {
            Strengths: '',
            Weaknesses: '',
          },
          Control: {
            Strengths: '',
            Weaknesses: '',
          },
          ManagerSupport: {
            Strengths: '',
            Weaknesses: '',
          },
          PeerSupport: {
            Strengths: '',
            Weaknesses: '',
          },
          Relationships: {
            Strengths: '',
            Weaknesses: '',
          },
          Role: {
            Strengths: '',
            Weaknesses: '',
          },
          Change: {
            Strengths: '',
            Weaknesses: '',
          },
        },
      },
      schoolName: '',
      surveyStartDate: '',
      surveyEndDate: '',
      SurveysCompletedPercentage: 0,
      IsSurveyClosed: false,
      errorMessage: null,
      isDataLoaded: false,
      latestSurveyOption: { value: '', label: 'Latest survey' },
      latestSurveyOptions: [{ value: SurveyTypes.any, label: 'Latest survey' }],
      isRole: userInfo.role,
      pdfname: 'school-report',
    };
  }

  componentDidMount() {
    this.props.navigationActions.activeItemAction({
      item: MenuItems.Report,
      showReportSubMenu: true,
    });
    this.getSurveyReportData();
    IsActionAllowed(RestrictedActions.Report)
      .then((response) => this.setState({ isPaid: response.data }))
      .catch();
    amplitudeLog('PageView', 'Report', '');
  }

  getSurveyReportData(token = null) {
    const { action } = this.props;
    action.dataLoading(true);
    const surveyToken = token ? '?token=' + token : window.location.search;
    surveyReportService
      .get(surveyToken)
      .then((response) => {
        const { success, data, message } = response;
        console.log(data);
        if (success) {
          navigationActions.setSchoolLogoUrl(response.data.logoUrl);
          storageService.setItem(
            WebStorageNames.schoolLogoUrl,
            response.data.logoUrl
          );
          this.setState({
            surveyReport: data.report,
            schoolName: data.schoolInfo.SchoolName,
            surveyStartDate: data.schoolInfo.SurveyStartDate,
            surveyEndDate: data.schoolInfo.SurveyEndDate,
            SurveysCompletedPercentage:
              data.schoolInfo.SurveysCompletedPercentage,
            IsSurveyClosed: data.IsSurveyClosed,
          });
          storageService.setItem(
            WebStorageNames.SchoolId,
            response.data.schoolInfo.SchoolId
          );
          setTimeout(() => {
            this.loadCurrentFragment();
          }, 500);
        } else {
          this.setState({ errorMessage: message });
          this.props.navigationActions.activeItemAction({
            item: MenuItems.Report,
            showReportSubMenu: false,
            disableReportMenu: true,
          });
        }
        action.dataLoading(false);
        this.setState({ isDataLoaded: true });
      })
      .catch((response) => {
        action.dataLoading(false);
        this.setState({ isDataLoaded: true });
        return response;
      });
  }

  loadCurrentFragment() {
    let reportSection = window.location.hash.replace('#', '');

    if (!isEmpty(reportSection)) {
      var fragment = document.getElementById(reportSection);
      if (fragment) fragment.scrollIntoView(true);
    }

    this.props.navigationActions.activeItemAction({
      item: isEmpty(reportSection) ? MenuItems.Report : reportSection,
      showReportSubMenu: true,
      disableReportMenu: false,
    });
  }

  redirectToPresentation(id) {
    var surveyToken = window.location.search;
    this.props.history.push(
      routesObj.ManagementStandards.path + surveyToken + '&categoryId=' + id
    );
  }

  redirectToFurtherSuggestions(id) {
    var surveyToken = window.location.search;
    this.props.history.push(
      routesObj.OtherSuggestion.path + surveyToken + '&categoryId=' + id
    );
  }

  redirectToRoute(routeName) {
    this.props.history.push(routeName);
  }

  print = () => {
    const {
      surveyReport,
      schoolName,
      surveyStartDate,
      surveyEndDate,
      SurveysCompletedPercentage,
    } = this.state;
    const { Demands, Control, ManagerSupport, Role, Relationships, Change } =
      surveyReport;

    amplitudeLog('Report', 'Download', '');
    var demandData = this.printHtml(Demands, 'demands', 'Demands');
    var controldData = this.printHtml(Control, 'control', 'Control');
    var supportData = this.printSupportHtml(
      ManagerSupport,
      'support',
      'Support'
    );
    var relationshipData = this.printHtml(
      Relationships,
      'relationship',
      'Relationship'
    );
    var roleData = this.printHtml(Role, 'role', 'Role');
    var changeData = this.printHtml(Change, 'change', 'Change');
    var skillsCareerData = this.printSkillsCareerHtml(
      7,
      'skills',
      'Skills and Career'
    );
    const learnMoreUrl = config.APP_URL + 'learn-more';

    var html =
      '<html><head><title>Welbee</title><style>@media print{.page-break-style{margin-bottom: 30px; width: 100%; float: left;} .other-suggestions {font-weight: 500 !important;} ul {padding: 0 30px !Important;} ol {padding: 0 30px !Important;} p {font-weight: 500 !important;} .sub-heading-message-support {font-weight: 400; padding: 0 32px; line-height: 30px;} .sub-heading-message {font-weight: 400; padding: 0 28px; line-height: 30px;}.report-list-wrapper{padding-right: 30px; padding-left: 30px;font-weight: 500;} .report-list-wrapper ul {padding-left: 30px; } .report-list-wrapper ul li p {font-weight: 500;padding: 0;margin: 0; }.report-list-wrapper ol li p {font-weight: 500 !important;padding: 0;margin: 0; } ol li p {font-weight: 500 !important; padding: 0 !important;}  ol li p span {font-weight: 500 !important; }   .report-list-wrapper ol {padding-left: 30px;font-weight: 500; } .sub-heading{padding-left: 30px; } .undeline-title{    text-decoration: underline;} h1 {padding-left 0 !important; }  .description-title {padding-right: 30px !important; padding-left: 50px !important;}  .skill-heading { float: left; width: 100%;}ol li ul li{text-indent: -1em !important; } ol li ul li::before {content: "•" !important;  } ol li{ text-indent: -.5em; } ol li::before { content: "" !important;  } #demandsSuggestions,#controlSuggestions, #supportSuggestions, #roleSuggestions, #relationshipSuggestions,  #changeSuggestions  ul  li {margin-top: 25px;}.relation-score{margin: 20px auto 0 auto !important;} .change-score{margin: 40px auto 0 auto !important; }.report-score{margin: 0px auto 0 auto !important; width: 100% !important; padding: 24px 0 !important; border-top: none;border-bottom: none;} #supportTitle{ page-break-after: always;}.demandsData{float: left; width: 100%; background-color: #ffffff; -webkit-print-color-adjust: exact; } .control-text {font-weight:400; } ol{margin: 0 0 0 0 !important}ol li, ol li p{margin-top: 0 !important;font-weight:500;padding: 0;margin: 0;} .next-steps-print ol li{ text-indent: 0 !important;}.next-steps-print ol li .secondaryList ul li {margin-left: 0 !important; padding-left: 20px; text-indent: -1.2em !important; } .next-steps-print .secondaryList ul li::before { content: \'•\' !important;color: #FFCF05 !important; font-size: 15px !important;margin-right: 10px !important;}.next-steps-print ul li {padding-left: 0; text-indent: -1.2em !important;} #nextStep li{margin-left: 0 !important;} .comp-strength li{margin-left: 0 !important;}li { margin-left: 20px !important; padding-left: 20px;  text-indent: -1.2em; } .all-score li {  padding-left: 0 !important; text-indent: 0 !important; margin-left: 0 !important} ol { padding: 0 30px; margin: 0 0 30px 0;line-height: 1.6;} ol li { color: #363636; font-size: 16px; padding: 0;  text-align: left;  margin: 0; width: 100%; font-weight: 400; line-height: 26px; margin-top: 11px;}  .comp-strength .sub-heading { font-weight: 900 !important;padding-left:30px;} .secondaryList ul li {display: block; margin: 0; float: left; padding: 0;}.secondaryList ul {width: 100%; float: left; padding-left: 0;  } li p {padding: 0;font-weight: 500;font-size: 16px; width: 100%; text-indent: 0;line-height: 26px;margin-top: 14px;} .further-suggestion {color: #53B5E0 !important; display: none} .tableContainer li{color: #007A7A}.tableContainer ul li::before { content: none ;font-size: 0; margin-right: 0; } h1 {width: 100%; text-align: center;} h3 { padding: 0 110px; font-weight: 900}.demand-data{ float: left; width: 100%;  background: #FFFFFF;   color: #363636;   margin: 40px 0;    padding-top: 50px;  padding-bottom: 50px;}#demandsSuggestions h1{text-align: center; width: 100%;} li::before { content: "•";color: #FFCF05;font-size: 15px; margin-right: 10px;}#demandsSuggestions{padding: 0; margin: 0 0 30px 34px; list-style: disc !important;} #demandsSuggestions li{ color: #363636;font-size: 16px; }ul.guide-lines{padding: 0;  margin: 0 0 30px 34px; list-style: none;} .guide-lines li{ color: #363636;font-size: 16px; } p {color: #363636;font-size: 16px; padding: 0 5px;text-align: left;margin: 0;width: 100%;font-weight: 500;line-height: 34px;}.underline-title {color: #363636;font-size: 16px; text-align: left;margin: 0;width: 100%;font-weight: 900;line-height: 34px;} .sub-heading { font-weight: 900; line-height: 34px;    text-align: left;    color: #363636;} ul{list-style: none; word-break: break-word; }li{color: #363636;font-size: 16px;padding: 0;text-align: left;margin: 0; width: 100%;font-weight: 400;line-height: 26px; margin-top: 11px;} .survey-report-title-main span { display: block;}.survey-report-title{font-size:48px;width:100%;line-height:58px;font-weight:900;color:#363636;text-align:center;margin:auto}.titleMainContainer{width:100%;width:569px;margin:30px auto;color:#363636;text-align:center;font-weight:900;word-spacing:2px;font-size:14px}.titleSubContainer{width:100%;width:569px;margin:30px auto;color:#000;text-align:center;font-weight:900;word-spacing:2px;font-size:14px}.titleSubContainer .span1{color:#ff5939}.titleSubContainer .span2{color:#53b5e0}.introText a {color: #53B5E0;font: 400 16px Avenir; word-spacing: 2px; margin: 0 3px 0 3px !important; text-align: left; margin: 0; background: transparent; border: 0;  cursor: pointer; padding: 0;text-decoration: none;}.introText{font-size:14px;line-height:28px;color:#363636;font-weight:400;width:90%;margin:auto} .bodyContainer{ padding-right: 0; padding-left: 0;  background:#fff; float: left;text-align:left; width: 1300px color:#363636; padding-bottom: 0; padding-top: 30px; }.report-title{color:#363636;font-size:36px;padding:0 0 27px 0;text-align:left !important; margin:0;width:100%;font-weight:900}.bodyContainer p{color:#363636;font-size:16px;padding:0 30px;text-align:left;margin:0;width:100%;font-weight:900;line-height:34px;box-shadow: none !important;}.tableContainer{ color:#007a7a;border-top:none;border-bottom:none;padding:0px 60px;width:90%;margin:auto;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between}.tableContainer ul{list-style:none;width:100%;padding:0;margin:0}.tableContainer ul li{color:#007a7a;font-size:25px;width:20%;font-weight:900;float:left;text-align:center} ol li { color: #363636; font-size: 16px; padding: 0;  text-align: left;  margin: 0; width: 100%; font-weight: 400; line-height: 26px; margin-top: 11px;} .tableContainer ul li span{display:block;width:71px;font-size:12px;font-weight:900;margin:auto;line-height:19px;margin-top:10px}}  table {page-break-before: always;margin: 0;padding: 0;} tr{page-break-before: always;margin: 0;padding: 0;} </style></head><body>';

    html += `<div style="page-break-after: always;"><h1 class="survey-report-title"><span>${schoolName}</span><span> Survey Results and Commentary</span></h1>`;

    html += `<div class="titleMainContainer"><div class="titleSubContainer">Survey sent on<span class="span1"> ${surveyStartDate}</span> and closed on<span class="span1"> ${surveyEndDate} </span></div><div class="titleSubContainer">Completed by <span class="span2">${SurveysCompletedPercentage > 100 ? 100 : SurveysCompletedPercentage
      }% of staff </span></div></div>`;
    html += `<div class="introText">Management Standards cover six key areas of work design and define the characteristics (culture) of a school, where the risks of work related stress and staff wellbeing are being effectively managed and controlled. Your staff survey is a key part of these Management Standards.<br/><br/>Below you will see your results against each of these six areas, showing your strengths, areas for focus and recommended actions. You should use these in conjunction with your school data, for example, absence, turnover, {t('behviour')}, grievances and performance to plan the steps you will take.<br/><br/>For full details of the management standards and guidance on your results and how you benchmark against other schools and organisations, use the <a href="https://knowledge.welbee.co.uk/" target="_blank">User Guide</a> link.</div></div>`;
    html += '<table>';
    html +=
      '<tr><th><div class="demandsData">' + demandData + '</div></th></tr>';
    html += '</table><table>';
    html += '<tr><th><div>' + controldData + '</div></th></tr>';
    html += '</table><table>';
    html += '<tr><th><div>' + supportData + '</div></tr>';
    html += '</table><table>';
    html += '<tr><th><div>' + relationshipData + '</div></th></tr>';
    html += '</table><table>';
    html += '<tr><th><div>' + roleData + '</div></th></tr>';
    html += '</table><table>';
    html += '<tr><th><div>' + changeData + '</div></th></tr>';
    html += '</table><table>';
    html += '<tr><th><div>' + skillsCareerData + '</div></th></tr>';
    html += '</table><table>';
    html +=
      '<tr><th><div><div><div class="bodyContainer">' +
      document.getElementById('nextStep').innerHTML +
      '</div></div></div></th></tr>';
    html += '</table>';
    html += '</body></html>';
    var oldPage = document.body.innerHTML;
    document.body.innerHTML = html;
    //window.print();
    document.body.innerHTML = oldPage;
    window.location.reload();
  };
  printSkillsCareerHtml(number, id, title) {
    let html = '';
    html +=
      '<div><div class="bodyContainer" style="padding:0 30px;"><h1  class="report-title" style="display: none">' +
      number +
      '. ' +
      title +
      '</h1>';

    html +=
      '<div>' + document.getElementById('skillsData').innerHTML + '</div>';

    html += '</div></div>';
    return html;
  }
  printHtml(category, id, title) {
    const { Category } = category;
    let html = '';

    html +=
      '<div><div class="bodyContainer" ><h1  class="report-title">' +
      Category +
      '. ' +
      title +
      '</h1>';
    html += '<p>' + document.getElementById(id + 'Title').innerHTML + '</p>';
    html +=
      '<p style="font-size:20px;font-weight:700;text-align:center">Overall Scores and Deciles</p>';
    html +=
      '<div class="tableContainer report-score"  style="page-break-before: avoid;">' +
      document.getElementById(id + 'Score').innerHTML +
      '</div>';

    if (document.getElementById('RoleWise' + id + 'Score') !== null) {
      html +=
        '<p style="font-size:20px;font-weight:700;text-align:center" >Scores by Job Role</p>';
      html +=
        '<div class="tableContainer report-score"  style="page-break-before: avoid;">' +
        document.getElementById('RoleWise' + id + 'Score').innerHTML +
        '</div>';
    }
    html +=
      '<div>' +
      document.getElementById(id + 'Description').innerHTML +
      '</div>';
    html +=
      '<table><tr><th><div>' +
      document.getElementById(id + 'Results').innerHTML +
      '</div></th></tr></table>';

    html +=
      '<table><tr><th><div>' +
      document.getElementById(id + 'Suggestions').innerHTML +
      '</div></th></tr></table>';

    html += '</div></div>';
    return html;
  }

  printSupportHtml(category, id, title) {
    const { Category } = category;
    let html = '';
    html +=
      '<div><div class="bodyContainer"><h1  class="report-title">' +
      Category +
      '. ' +
      title +
      '</h1>';
    html += '<p>' + document.getElementById(id + 'Title').innerHTML + '</p>';

    html +=
      '<div>' +
      document.getElementById(id + 'Description').innerHTML +
      '</div>';

    let individualAnswerBtns = document.getElementsByClassName(
      'support-individual-answer'
    );

    forEach(individualAnswerBtns, (item) => (item.hidden = true));

    html +=
      '<table><tr><th><div>' +
      document.getElementById(id + 'Results').innerHTML +
      '</div></th></tr></table>';

    html += '</div></div>';
    return html;
  }
  routeToAccount = () => {
    this.props.history.push(routesObj.Account.path);
  };
  downloadSurveyReport = () => {
    const surveyToken = getQueryStringVal(QueryStringTokens.token);
    const schoolToken = getQueryStringVal(QueryStringTokens.schoolToken);

    surveyService
      .getSurveysNameAndToken(surveyToken)
      .then((response) => {
        const surveyRecordList = getTransformedSurveyRecordList(response.data);
        const token = window.location.search;
        var selectedRecord = surveyRecordList.filter(
          (item) => '?token=' + item.value === token
        );
        if (selectedRecord.length > 0) {
          this.setState({ pdfname: selectedRecord[0].label });
        }
      })
      .catch((error) => console.log(error));
    surveyResultService
      .GetPDFSurveyReport(surveyToken, schoolToken)
      .then((response) => {
        const url = window.URL.createObjectURL(
          new Blob([response], { type: 'application/pdf' })
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.state.pdfname + '.pdf');
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => { });
  };

  handleDrawerToggle = () => {
    //setMobileOpen(!mobileOpen);
    this.setState({ mobileOpen: !this.state.mobileOpen });
  };

  render() {
    const { t } = this.props;
    const {
      surveyReport,
      schoolName,
      surveyStartDate,
      surveyEndDate,
      SurveysCompletedPercentage,
      IsSurveyClosed,
      errorMessage,
      mobileOpen,
    } = this.state;
    const {
      Demands,
      Control,
      ManagerSupport,
      PeerSupport,
      Role,
      Relationships,
      Change,
      Skills,
      Career,
      NextSteps,
    } = surveyReport;

    {
      /* report links */
    }
    const drawer = (
      <div className='report-links'>
        <div className='report-arrow'>
          <ArrowForwardIosIcon sx={{ fontSize: '18px' }} />
        </div>
        <ul className='sub-list'>
          <li>
            <a
              className='btn-report btn-demand'
              data-test-id='demandMenu'
              href='#demands'
              onClick={() => {
                this.navigateBackToReport();
                this.onClickHandler({
                  name: MenuItems.ReportSubMenu.Demands,
                  showReportSubMenu: true,
                });
                amplitudeLog('Report', 'SideMenuDemands', '');
              }}
            >
              Demands
            </a>
          </li>

          <li>
            <a
              className='btn-report btn-control'
              data-test-id='controlMenu'
              href='#control'
              onClick={() => {
                this.navigateBackToReport();
                this.onClickHandler({
                  name: MenuItems.ReportSubMenu.Control,
                  showReportSubMenu: true,
                });
                amplitudeLog('Report', 'SideMenuControl', '');
              }}
            >
              Control
            </a>
          </li>
          {this.state.isPaid ? (
            <li>
              <a
                className='btn-report btn-support'
                data-test-id='supportMenu'
                href='#support'
                onClick={() => {
                  this.navigateBackToReport();
                  this.onClickHandler({
                    name: MenuItems.ReportSubMenu.Support,
                    showReportSubMenu: true,
                  });
                  amplitudeLog('Report', 'SideMenuSupport', '');
                }}
              >
                Support
              </a>
            </li>
          ) : null}

          {this.state.isPaid ? null : (
            <li>
              <a
                className='btn-report btn-manager'
                data-test-id='supportMenu'
                href='#supportManager'
                onClick={() => {
                  this.navigateBackToReport();
                  this.onClickHandler({
                    name: MenuItems.ReportSubMenu.SupportManager,
                    showReportSubMenu: true,
                  });
                  amplitudeLog('Report', 'SideMenuSupport', '');
                }}
              >
                Support Manager
              </a>
            </li>
          )}
          {this.state.isPaid ? null : (
            <li>
              <a
                className='btn-report btn-peer'
                data-test-id='supportMenu'
                href='#supportPeer'
                onClick={() => {
                  this.navigateBackToReport();
                  this.onClickHandler({
                    name: MenuItems.ReportSubMenu.SupportPeer,
                    showReportSubMenu: true,
                  });
                  amplitudeLog('Report', 'SideMenuSupport', '');
                }}
              >
                Support Peer
              </a>
            </li>
          )}
          <li>
            <a
              className='btn-report btn-relationship'
              data-test-id='relationMenu'
              href='#relation'
              onClick={() => {
                this.navigateBackToReport();
                this.onClickHandler({
                  name: MenuItems.ReportSubMenu.Relationships,
                  showReportSubMenu: true,
                });
                amplitudeLog('Report', 'SideMenuRelationships', '');
              }}
            >
              Relationships
            </a>
          </li>
          <li>
            <a
              className='btn-report btn-role'
              data-test-id='roleMenu'
              href='#role'
              onClick={() => {
                this.navigateBackToReport();
                this.onClickHandler({
                  name: MenuItems.ReportSubMenu.Role,
                  showReportSubMenu: true,
                });
                amplitudeLog('Report', 'SideMenuRole', '');
              }}
            >
              Role
            </a>
          </li>
          <li>
            <a
              className='btn-report btn-change'
              data-test-id='changeMenu'
              href='#change'
              onClick={() => {
                this.navigateBackToReport();
                this.onClickHandler({
                  name: MenuItems.ReportSubMenu.Change,
                  showReportSubMenu: true,
                });
                amplitudeLog('Report', 'SideMenuChange', '');
              }}
            >
              Change
            </a>
          </li>

          <li>
            <a
              className='btn-report btn-steps'
              data-test-id='nextStepsMenu'
              href='#next-steps'
              onClick={() => {
                this.navigateBackToReport();
                this.onClickHandler({
                  name: MenuItems.ReportSubMenu.NextSteps,
                  showReportSubMenu: true,
                });
                amplitudeLog('Report', 'SideMenuNextSteps', '');
              }}
            >
              Next steps
            </a>
          </li>
        </ul>
      </div>
    );

    return !this.state.isDataLoaded ? (
      <div />
    ) : (
      <AccessLevel permissions={[AccessPermissions.Full, AccessPermissions.HeadTeacher, AccessPermissions.View]} >
        <div>
          <AdminHeader />
          <SurveyReportWrapper className='survey-main-wrapper'>
            <div className='left-container'>
              <LeftMenu />
            </div>

            <div className='right-container'>
              <MainHeader />

              <Grid container>
                <Grid item md={12} xs={12}>
                  <AssistanceWrapper>
                    <div className='header-bottom'>
                      <div className='btn-download'>
                        {IsSurveyClosed ? (
                          this.state.isPaid ? (
                            <Tooltip title='Download' followCursor>
                              <DownloadButtonStyle
                                data-id-div='reportDownload'
                                onClick={this.downloadSurveyReport}
                              >
                                <img src={iconDownload} alt='' />{' '}
                                <span>Download</span>
                              </DownloadButtonStyle>
                            </Tooltip>
                          ) : (
                            <Tooltip title='Download' followCursor>
                              <DownloadButtonStyle
                                data-id-div='reportDownload'
                                className='tooltip'
                              >
                                <img src={iconDownload} alt='' />{' '}
                                <span>Download</span>
                                <span className='tooltiptext'>
                                  You can download the heatmaps by upgrading your
                                  account.
                                </span>
                              </DownloadButtonStyle>
                            </Tooltip>
                          )
                        ) : (
                          <div />
                        )}
                      </div>
                      <div className='dd-survey'>
                        <SurveyListDropDown />
                      </div>
                    </div>
                  </AssistanceWrapper>
                </Grid>

                {!IsSurveyClosed || !isEmpty(errorMessage) ? (
                  isEmpty(errorMessage) ? (
                    <SurveyReportInnerWrapper>
                      <Grid item md={12} xs={12}>
                        <div className='report-not-available'>
                          Your report will be available as soon as you run and
                          close your survey.
                        </div>
                      </Grid>
                    </SurveyReportInnerWrapper>
                  ) : !isEmpty(errorMessage) ? (
                    <SurveyReportInnerWrapper>
                      <Grid item md={12} xs={12}>
                        <div className='report-not-available'>{errorMessage}</div>
                      </Grid>
                    </SurveyReportInnerWrapper>
                  ) : (
                    <div />
                  )
                ) : (
                  <SurveyReportInnerWrapper>
                    <Grid container>
                      <Grid item xl={11} lg={11} md={10} sm={10} xs={12}>
                        <h1 className='survey-report-title'>
                          {/* <span>{schoolName}</span>{' '} */}
                          <span>Survey Results and Commentary</span>
                        </h1>

                        <SubHeading>
                          <SurveyDate>
                            Survey opened on <span>{surveyStartDate}</span> and
                            closed on
                            <span> {surveyEndDate}</span>
                          </SurveyDate>
                          <SurveyCompleted>
                            Completed by{' '}
                            <span>
                              {SurveysCompletedPercentage > 100
                                ? 100
                                : SurveysCompletedPercentage}
                              % of staff
                            </span>
                          </SurveyCompleted>
                        </SubHeading>

                        <SurveyReportIntro>
                          <p>
                            Management Standards cover six key areas of work
                            design and define the characteristics (culture) of a
                            school, where the risks of work related stress and
                            staff wellbeing are being effectively managed and
                            controlled. Your staff survey is a key part of these
                            Management Standards.
                          </p>
                          {this.state.isPaid ? (
                            <div>
                              <p>
                                Below you will see your results against each of
                                these six areas, showing your strengths, areas for
                                focus and recommended actions. You should use
                                these in conjunction with your school data, for
                                example, absence, turnover, {t('behviour')},
                                grievances and performance to plan the steps you
                                will take.
                              </p>
                              <p>
                                For full details of the management standards and
                                guidance on your results and how you benchmark
                                against other schools and {t('organisations')},
                                visit the{' '}
                                <a
                                  href='https://knowledge.welbee.co.uk/'
                                  target='_blank'
                                >
                                  User Guide.
                                </a>{' '}
                              </p>
                            </div>
                          ) : (
                            <div>
                              <p>
                                Below you will see your results against each of
                                these six areas, showing your strengths, areas for
                                focus and recommended actions. You should use
                                these in conjunction with your school data, for
                                example, absence, turnover, {t('behviour')},
                                grievances and performance to plan the steps you
                                will take.
                              </p>
                              <p>
                                Below you will see your summary results against
                                each of these areas.
                              </p>
                              <p>
                                Further analysis is available to show your
                                strengths, areas for focus and recommended actions
                                in each of the Standards, and to show your
                                comparative performance against the school and
                                Health and Safety Executive benchmarks. For
                                details of how to upgrade your subscription{' '}
                                <a
                                  href='javascript:void(0);'
                                  onClick={this.routeToAccount}
                                >
                                  click here.
                                </a>
                              </p>
                              <p>
                                This information, together with your school data,
                                for example, absence, turnover, {t('behviour')},
                                grievances and performance, can be used as the
                                basis to plan the steps you will take.
                              </p>
                              <p>
                                For full details of the management standards,
                                guidance on your results and details of how to
                                obtain further analysis and access benchmark data,
                                visit the{' '}
                                <a
                                  href='https://knowledge.welbee.co.uk/'
                                  target='_blank'
                                >
                                  User Guide.
                                </a>{' '}
                              </p>
                            </div>
                          )}
                          <div id='demands' />
                        </SurveyReportIntro>
                      </Grid>
                    </Grid>

                    <Grid container spacing={2}>
                      <Grid item lg={12} md={12} xs={12}>
                        <DemandReport
                          report={Demands}
                          isPaid={this.state.isPaid}
                          onButtonClick={() => {
                            amplitudeLog(
                              'Report',
                              'DemandsIndividualAnswers',
                              ''
                            );
                            this.redirectToPresentation(
                              questionCategoryType.Demands.Id
                            );
                          }}
                          onFurtherSuggestionClick={() =>
                            this.redirectToFurtherSuggestions(
                              questionCategoryType.Demands.Id
                            )
                          }
                        />

                        <ControlReport
                          report={Control}
                          isPaid={this.state.isPaid}
                          onButtonClick={() => {
                            amplitudeLog(
                              'Report',
                              'ControlIndividualAnswers',
                              ''
                            );
                            this.redirectToPresentation(
                              questionCategoryType.Control.Id
                            );
                          }}
                          onFurtherSuggestionClick={() =>
                            this.redirectToFurtherSuggestions(
                              questionCategoryType.Control.Id
                            )
                          }
                        />

                        {this.state.isPaid ? (
                          <SupportReport
                            reportManagerSupport={ManagerSupport}
                            reportPeerSupport={PeerSupport}
                            onFurtherSuggestionClick={() =>
                              this.redirectToFurtherSuggestions(
                                questionCategoryType.Support.Id
                              )
                            }
                            onManagersButtonClick={() => {
                              amplitudeLog(
                                'Report',
                                'SupportIndividualAnswers',
                                ''
                              );
                              this.redirectToPresentation(
                                questionCategoryType.Support.Id
                              );
                            }}
                            onPeerButtonClick={() => {
                              amplitudeLog(
                                'Report',
                                'SupportIndividualAnswers',
                                ''
                              );
                              this.redirectToPresentation(
                                questionCategoryType.PeerSupport.Id
                              );
                            }}
                          />
                        ) : null}

                        {this.state.isPaid ? null : (
                          <SupportManagerReport
                            reportManagerSupport={ManagerSupport}
                            onManagersButtonClick={() => {
                              amplitudeLog(
                                'Report',
                                'SupportIndividualAnswers',
                                ''
                              );
                              this.redirectToPresentation(
                                questionCategoryType.Support.Id
                              );
                            }}
                          />
                        )}

                        {this.state.isPaid ? null : (
                          <SupportPeerReport
                            reportPeerSupport={PeerSupport}
                            onPeerButtonClick={() => {
                              amplitudeLog(
                                'Report',
                                'SupportIndividualAnswers',
                                ''
                              );
                              this.redirectToPresentation(
                                questionCategoryType.PeerSupport.Id
                              );
                            }}
                          />
                        )}

                        <RelationshipReport
                          report={Relationships}
                          isPaid={this.state.isPaid}
                          onButtonClick={() => {
                            amplitudeLog(
                              'Report',
                              'RelationshipIndividualAnswers',
                              ''
                            );
                            this.redirectToPresentation(
                              questionCategoryType.Relationships.Id
                            );
                          }}
                          onFurtherSuggestionClick={() =>
                            this.redirectToFurtherSuggestions(
                              questionCategoryType.Relationships.Id
                            )
                          }
                        />
                        <RoleReport
                          report={Role}
                          isPaid={this.state.isPaid}
                          onButtonClick={() => {
                            amplitudeLog('Report', 'RoleIndividualAnswers', '');
                            this.redirectToPresentation(
                              questionCategoryType.Role.Id
                            );
                          }}
                          onFurtherSuggestionClick={() =>
                            this.redirectToFurtherSuggestions(
                              questionCategoryType.Role.Id
                            )
                          }
                        />
                        <ChangeReport
                          report={Change}
                          isPaid={this.state.isPaid}
                          onButtonClick={() => {
                            amplitudeLog('Report', 'ChangeIndividualAnswers', '');
                            this.redirectToPresentation(
                              questionCategoryType.Change.Id
                            );
                          }}
                          onFurtherSuggestionClick={() =>
                            this.redirectToFurtherSuggestions(
                              questionCategoryType.Change.Id
                            )
                          }
                        />

                        <NextStepsReport
                          report={NextSteps}
                          isPaid={this.state.isPaid}
                          routeToAccount={this.routeToAccount}
                        />
                      </Grid>

                      <Grid item lg={2} md={3} xs={12}>
                        <IconButton
                          className='report-toggle-menu'
                          aria-label='open drawer'
                          edge='start'
                          onClick={this.handleDrawerToggle}
                        //sx={{ mr: 2 }}
                        >
                          <span>Navigation</span>
                          <MenuIcon />
                        </IconButton>

                        {/* For mobile and tablet view */}
                        <Drawer
                          variant='persistent'
                          anchor='right'
                          open={mobileOpen}
                          onClose={this.handleDrawerToggle}
                          onClick={this.handleDrawerToggle}
                          ModalProps={{
                            keepMounted: true, // Better open performance on mobile.
                          }}
                          sx={{
                            display: {
                              xs: 'block',
                              sm: 'block',
                              md: 'block',
                              lg: 'block',
                            },
                            '& .MuiDrawer-paper': {
                              boxSizing: 'border-box',
                              width: drawerWidth,
                            },
                          }}
                          className='report-filters-drawer'
                        >
                          {drawer}
                        </Drawer>

                        {/* For desktop view */}
                        {/* <Drawer
                        variant="persistent"
                        anchor='right'
                        sx={{
                          display: { xs: 'none', sm: 'none' },
                        }}
                        open
                      >
                        {drawer}
                      </Drawer> */}
                      </Grid>
                    </Grid>
                  </SurveyReportInnerWrapper>
                )}
              </Grid>
            </div>
          </SurveyReportWrapper>
        </div>
      </AccessLevel>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  action: bindActionCreators(loaderAction, dispatch),
  navigationActions: bindActionCreators(navigationActions, dispatch),
});

export default connect(
  null,
  mapDispatchToProps
)(withRouter(withTranslation()(SurveyReport)));
